import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const TaskDraftIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 -0.5 21 23"
      fill="none"
    >
      <g>
        <path
          d="M19 7.4V3.7C19 2.9 18.3 2.1 17.5 2.1H15.4"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.25}
        />
        <path
          d="M5.5 2.1H3.5C2.7 2.1 2 2.8 2 3.7V19.5C2 20.4 2.7 21.1 3.5 21.1H4.8"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.25}
        />
        <path
          d="M15.3 2.1C15.3 1.2 14.6 0.5 13.6 0.5H7.29997C6.39997 0.5 5.69998 1.2 5.59998 2.1V4H15.3V2.1Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.25}
        />
        <path
          d="M9.90002 17.4L16.1 11.2C16.3 11 16.7 11 17 11.2L18.9 13.1C19.1 13.3 19.1 13.7 18.9 14L12.7 20.2"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.25}
        />
        <path
          d="M9.90002 17.4L8.40002 21.6L12.6 20.1L11.6 19.1L10.5 18L9.90002 17.4Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.25}
        />
      </g>
    </svg>
  </CircledIcon>
);
